import { useQuery } from "@tanstack/react-query";
import { withNamespaces } from "react-i18next";
import { toast } from "react-toastify";
import { Card, CardBody, CardTitle } from "reactstrap";
import ComplianceMonitoringDashboardService from "src/modules/3rd-party-management/apis/admin/compliance/monitoring/DashboardService";
import SimpleBar from "simplebar-react";
import DateUtils from "src/services/utils/DateUtils";
import { 
    INTERNATIONAL_DATE_FORMAT
} from "src/common/constants";
import { HistoryLogActions } from "src/modules/3rd-party-management/constants";

const RecentActivities = ({ t, filters }) => {
    const dateUtils = new DateUtils();

    const fetchDataQuery = useQuery({
        queryKey: [
            "3rd-party-management-fetch-compliance-monitoring-dashboard",
            "recent-activity",
            filters
        ],
        queryFn: async () => {
            const service = ComplianceMonitoringDashboardService.getInstance();

            return await service.fetchRecentActivities(filters);
        },
        refetchOnWindowFocus: false,
        onError: (error) => {
            if (process.env.NODE_ENV === 'development') console.error(error);

            toast(t("An error occurred while fetching dashboard data."), {
                type: "error"
            });
        }
    });

    if (fetchDataQuery.isFetching) {
        return (
            <Card>
                <CardBody>
                    <div className="dt-field dt-skeleton mb-2" style={{ width: '40%' }}></div>
                    <div className="dt-field dt-skeleton" style={{ width: '100%', height: '320px' }}></div>
                </CardBody>
            </Card>
        );
    }

    const {
        items = []
    } = fetchDataQuery.data || {};

    return (
        <Card className="h-100">
            <CardBody>
                <CardTitle>
                    {t('Recent Activity')}
                </CardTitle>

                <SimpleBar style={{ height: "318px" }}>
                    <ul className="list-unstyled activity-wid">
                        {
                            items.map((activity) => {
                                return (
                                    <li className="activity-list">
                                        <div className="activity-icon avatar-xs">
                                            <span className="avatar-title bg-soft-primary text-primary rounded-circle">
                                                <i className="ri-edit-2-fill"></i>
                                            </span>
                                        </div>
                                        <div>
                                            <div className="d-flex align-items-baseline justify-content-between">
                                                <h5 className="font-size-13">
                                                    {activity.user_name}
                                                </h5>

                                                <span>
                                                    {dateUtils.convertDateToDate(activity.created_at, INTERNATIONAL_DATE_FORMAT)}
                                                    <small className="ml-3 text-muted">
                                                        {' '} {dateUtils.convertDateToDate(activity.created_at, 'HH:mm')}
                                                    </small>
                                                </span>
                                            </div>

                                            <div>
                                                <p className="text-muted mb-0">
                                                    {t(HistoryLogActions[activity.section]?.[activity.action] || activity.action)}
                                                </p>
                                            </div>
                                        </div>
                                    </li>
                                );
                            })
                        }
                    </ul>
                </SimpleBar>
            </CardBody>
        </Card>
    )
}

export default withNamespaces()(
    RecentActivities
);